<div class="manual-ordered-parts-dialog">
    <div class="manual-ordered-parts-dialog-header flex-between-center">
        <div class="flex-start-center">
            <i class="fal fa-boxes font-primary flex-center-center header-icon mr-2"></i>
            <p class="m-0 font-18 flex-column flex-center-start">
                <span class="font-18 font-bold">Ordered part in [Service name]</span>
                <span class="font-16 font-gray-55">
                    This service has parts that have already been ordered
                </span>
            </p>
        </div>

        <span class="close-modal flex-start">
            <i class="fal fa-times font-20" (click)="handleClose()"></i>
        </span>
    </div>

    <div class="manual-ordered-part-dialog-body">
        <div class="item-order-part mb-2">
            <div class="item-card">
                <p class="font-bold mb-1">Caltex engine Oil 0V-40V</p>
                <div class="ui-g">
                    <div class="ui-g-3 p-0">
                        <p class="card-text font-gray-45 m-0">Price: $674<span class="border-right pl-15"></span></p>
                        <app-radio-button id="phone-primary-54" name="return-order1" label="Return"
                            styleClassLabel="font-seconday" [selectedValue]="12" [ngClass]="" [disabled]="false"
                            [value]="12">
                        </app-radio-button>
                    </div>
                    <div class="ui-g-5 p-0">
                        <p class="card-text font-gray-45 m-0">Cost: $423</p>
                        <app-radio-button id="phone-primary-5454" name="add-inventory1" label="Add to inventory"
                            styleClassLabel="font-seconday" [selectedValue]="" [ngClass]="" [disabled]="false"
                            [value]="34">
                        </app-radio-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="item-order-part mb-2">
            <div class="item-card">
                <p class="font-bold mb-1">Air filter for Honda civic</p>
                <div class="ui-g">
                    <div class="ui-g-3 p-0">
                        <p class="card-text font-gray-45 m-0">Price: $674<span class="border-right pl-15"></span></p>
                        <app-radio-button id="phone-primary-54" name="return-order2" label="Return"
                            styleClassLabel="font-seconday" [selectedValue]="" [ngClass]="" [disabled]="false"
                            [value]="2">
                        </app-radio-button>
                    </div>
                    <div class="ui-g-5 p-0">
                        <p class="card-text font-gray-45 m-0">Cost: $423</p>
                        <app-radio-button id="phone-primary-5454" name="add-inventory2" label="Add to inventory"
                            styleClassLabel="font-seconday" [selectedValue]="3" [ngClass]="" [disabled]="false"
                            [value]="3">
                        </app-radio-button>
                    </div>
                </div>
                <div class="ui-g">
                    <div class="pb-0 pl-0 pt-3 ui-g-7">
                        <app-dropdown id="est-workflow-status" listId="est-workflow-status-list"
                            inactiveItemsKey="statusActive" placeholder="Location" field="label" theme="border"
                            styleClassSelectedView="p-6p bg-white" scrollHeight="198px" [options]="[]" [disabled]="false"
                            [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true" [selectInactiveItems]="false"
                            [fullyControlled]="true" [value]="">
                            <ng-template let-item appTemplate="item">
                                <span class="font-12" [ngClass]="{'disabled-status': !item?.statusActive}">
                                    {{item.label}}</span>
                            </ng-template>
                        </app-dropdown>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="manual-ordered-parts-dialog-footer flex-end-center">
        <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">
            Cancel
        </button>

        <button class="btn btn-primary btn-submit" (click)="handleSubmit()">
            Save
        </button>
    </div>
</div>